/**
 * CSS Loader for Shadow DOM injection
 * 
 * This module provides the SDK's CSS as a string that can be injected
 * into Shadow DOM roots for complete style isolation.
 */

// Import CSS as inline string using Vite's ?inline query
// This imports the CSS file content as a string rather than injecting it into the document
import cssString from '../lib-styles.css?inline';

/**
 * Get the SDK's CSS styles as a string for shadow DOM injection.
 * 
 * @returns The complete CSS string for the Aria SDK
 * 
 * @example
 * ```tsx
 * import { getAriaStyles } from '@centive/aria-sdk';
 * 
 * // Use with ShadowContainer
 * <ShadowContainer styles={getAriaStyles()}>
 *   <AriaWidget />
 * </ShadowContainer>
 * ```
 */
export function getAriaStyles(): string {
  return cssString;
}

/**
 * The raw CSS string for the Aria SDK.
 * Use this if you need direct access to the CSS string.
 */
export const ariaStyles = cssString;

export default cssString;
